(function(){
function fixCards(){
  // Handle product-card custom elements
  document.querySelectorAll('product-card').forEach(function(card){
    if(card.dataset.fixed) return;
    card.dataset.fixed='1';
    hydrateCard(card);
  });
  // Handle bare anchor cards
  document.querySelectorAll('a.product-card__link').forEach(function(link){
    if(link.dataset.fixed) return;
    // Skip if already inside a fixed product-card
    if(link.closest('product-card[data-fixed="1"]')) return;
    link.dataset.fixed='1';
    var url=link.getAttribute('href')||'#';
    var title=link.getAttribute('aria-label')||link.textContent.trim()||'Product';
    // Try to find image
    var img=link.querySelector('img');
    var imgUrl=img?img.src:'';
    if(!imgUrl){
      var card=link.closest('[data-featured-media-url]');
      if(card) imgUrl=card.dataset.featuredMediaUrl;
    }
    if(!link.innerHTML.trim()){
      link.innerHTML=(imgUrl?'<img src="'+imgUrl+'" alt="" style="width:100%;height:auto;display:block;aspect-ratio:1;object-fit:cover;" loading="lazy">':'')+'<div style="padding:12px 4px;font-weight:600;font-size:14px;">'+title+'</div>';
      link.style.display='block';
      link.style.textDecoration='none';
      link.style.color='inherit';
    }
  });
}
function hydrateCard(card){
  var link=card.querySelector('a.product-card__link');
  var content=card.querySelector('.product-card__content');
  if(!link) return;
  var url=link.getAttribute('href')||'#';
  var title=link.getAttribute('aria-label')||'';
  var imgUrl=card.dataset.featuredMediaUrl||'';
  var target=content||link;
  if(!target.innerHTML.trim()){
    target.innerHTML='<a href="'+url+'" style="display:block;text-decoration:none;color:inherit;">'+(imgUrl?'<img src="'+imgUrl+'" alt="" style="width:100%;height:auto;display:block;aspect-ratio:1;object-fit:cover;" loading="lazy">':'')+'<div style="padding:12px 4px;font-weight:600;font-size:14px;">'+title+'</div></a>';
  }
}
function init(){
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fixCards);}
  else{fixCards();}
  setTimeout(fixCards,1500);setTimeout(fixCards,3000);
}
init();
})();